import {
    Directive, ElementRef,
    Input,
    Renderer2,
} from '@angular/core';

@Directive({ selector: '[shimmer]' })
export class ShimmerDirective {
    /**
     * Should shimmer effect be shown
     */
    @Input() shimmer: boolean = true;

    /**
     * Reference to shimmer element
     */
    private shimmerEl?: HTMLElement;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    /**
     * Handle input changes
     */
    ngOnChanges(): void {
        // Enable shimmer
        if (this.shimmer && !this.shimmerEl) {
            const element = this.el.nativeElement;
            this.renderer.setStyle(element, 'position', 'relative');
            this.renderer.setStyle(element, 'overflow', 'hidden');

            this.shimmerEl = this.renderer.createElement('div');
            this.renderer.addClass(this.shimmerEl, 'shimmer-effect');
            this.renderer.setStyle(this.shimmerEl, 'position', 'absolute');
            this.renderer.setStyle(this.shimmerEl, 'top', '0');
            this.renderer.setStyle(this.shimmerEl, 'left', '-100%');
            this.renderer.setStyle(this.shimmerEl, 'width', '100%');
            this.renderer.setStyle(this.shimmerEl, 'height', '100%');
            this.renderer.setStyle(
                this.shimmerEl,
                'background',
                'linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.6), 50%, transparent 100%)',
            );
            this.renderer.setStyle(this.shimmerEl, 'animation', 'shimmer 1.5s infinite');

            this.renderer.appendChild(element, this.shimmerEl);
            // Disable shimmer
        } else if (!this.shimmer && this.shimmerEl) {
            this.renderer.removeChild(this.shimmerEl, this.shimmerEl);
            this.shimmerEl = undefined;
        }
    }
}
